import { get } from "lodash";
import { useSite } from "./use-site";
export var useTermsPagePath = function useTermsPagePath() {
  var site = useSite(); // legacy falback

  return get(site, 'termsPage.path', process.env.TERMS_PATH || '');
};